import React from "react";
import { Row, Col } from "react-bootstrap";
import "./OpenTime.scss";

class OpenTime extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getText = (text) => {
    const { loadTranslations, currentLanguage } = this.props;
    return loadTranslations(text, currentLanguage);
  };

  render() {
    return (
      
       <section
       className="openTime-wrap relative"
       data-stellar-background-ratio="0.5"
       style={{ padding: "50px 0", background: "#4c6575", color: "#ffffff" }}
     >
       <Row>
         <Col lg={6} md={6} sm={6} xs={12} style={{ borderRight: '1px solid #ffffff' }}>
           <Row className="margin-bottom10">
             <Col lg={12} md={12} sm={12} xs={12} className="np-left">
               <h4>
                 Als Gruppenpraxis bieten wir folgende Öffnungszeiten an:
               </h4>
             </Col>
           </Row>
           <Row>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left">
                        <p>Montag,&nbsp;&nbsp;Dienstag<br />Mittwoch,&nbsp;&nbsp;Freitag</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p>7.30 - 12.00 Uhr</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p>13.30 - 18.00 Uhr</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={6} xs={12} className="np-left">
                        <p>Donnerstag</p>
                      </Col>
                      <Col lg={4} md={4} sm={6} xs={12} className="np-left">
                        <p>7.30 - 12.00 Uhr</p>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left">
                        <p>Samstag</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left">
                        <p>7.30 - 12.00 Uhr</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={12} />
                    </Row>
         </Col>
         <Col lg={6} md={6} sm={6} xs={12}>
           <Row className="margin-bottom10">
             <Col lg={6} md={6} sm={6} xs={12}>
               <h4>Telefonische Erreichbarkeit:</h4>
             </Col>
             <Col lg={2} md={2} sm={1} xs={1} />
             <Col lg={4} md={4} sm={5} xs={12} className="np-left">
               <h4 className="nm-top">Tel. 062 296 50 55</h4>
             </Col>
           </Row>
           <Row>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left p-left">
                        <p>Montag,&nbsp;&nbsp;Dienstag<br />Mittwoch</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p>8.00 - 11.30 Uhr</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p>13.30 - 17.00 Uhr</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left p-left">
                        <p>Donnerstag</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p> 8.00 - 11.30 Uhr</p>
                      </Col>

                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left p-left">
                        <p>Freitag</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p>8.00 - 11.30 Uhr</p>
                      </Col>
                      <Col lg={4} md={4} sm={6} xs={6} className="np-left">
                        <p>13.30 - 16.30 Uhr</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} />
                    </Row>
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12} className="np-left p-left">
                        <p>Samstag</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} className="np-left">
                        <p>8.00 - 10.00 Uhr</p>
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={6} />
                    </Row>
           <Row>
             <Col
               lg={12}
               md={12}
               sm={12}
               xs={12}
               className="text-center"
             ></Col>
           </Row>
         </Col>
       </Row>
     </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.users.currentLanguage,
  };
}

export default OpenTime;



// WEBPACK FOOTER //
// ./screens/OpenTime/OpenTime.js